// extracted by mini-css-extract-plugin
export default {"screen":"screen__40ccc65d","LoginInfoBtn":"LoginInfoBtn__8a8cac6f","avatar":"avatar__ca7727bd","text":"text__117387c1"};